import { useFreshRef } from './useFreshRef.js';

/**
 * useFreshTick
 * @param callback The callback to be called on mount
 * @returns A fresh callback.
 * @see https://react-hooks.org/docs/useFreshCallback
 */
function useFreshTick(callback) {
    const freshRef = useFreshRef(callback);
    function tick(...args) {
        if (typeof freshRef.current === "function") {
            freshRef.current(...args);
        }
    }
    return tick;
}

export { useFreshTick };
